import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AuthGuard, I18nModule, provideConfig } from '@spartacus/core';
import {
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
} from '@spartacus/storefront';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { KbContactUsFormComponent } from './contact-us-form.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    MediaModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
  ],
  declarations: [KbContactUsFormComponent, PrivacyPolicyComponent],
  exports: [KbContactUsFormComponent, PrivacyPolicyComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        KbContactUsFormFlexComponent: {
          component: KbContactUsFormComponent,
          guards: [SecureGuard]
        },
      },
    }),
  ],
})
export class KbContactUsFormModule { }
